<template>
<div class="relateVideo">
  <div class="videos">
    <van-list
        v-model:loading="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
    >
      <div class="card_box">
        <router-link :to="{ name: 'VideoPlay', query: { pid: video.ID } }" class="v_card" v-for="video in videoList" :key="video.id" :title="video.Title" >
          <div class="card">
            <div class="img_wrap">
              <div class="bfs_img">
                <picture class="img_inner">

                  <img class="img"
                       :src="video.Cover"
                       :alt="video.Title"
                       loading="lazy"
                       @error="handleImageError"
                  >
                </picture>
              </div>
            </div>
            <div class="count">
              <div>
                  <span>
                  <i class="iconfont icon_shipin_bofangshu"></i>
                   {{ video.views }} <!-- 播放量 -->
                </span>
                <span>
                  <i class="iconfont icon_shipin_danmushu"></i>
                  {{ video.comments }} <!-- 弹幕数 -->
                </span>
              </div>
              <div>
                <span>6:35</span>
              </div>
            </div>
          </div>
          <p class="title">{{ video.Title }}</p>
        </router-link>
      </div>
    </van-list>
  </div>
</div>
</template>

<script>
export default {
  name: "RelateVideos",
  props:['vid', 'slug'],
  data(){
    return {
      count: 0,
      loading: false,
      finished: false,
      refreshing: false,
      videoList: [],
      finishedText : '没有更多了',
      offset:0,
      limit:20,
      imgErrPath: ""
    };
  },
  methods: {
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.offset = 0;
      this.onLoad();
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.videoList = [];
          this.refreshing = false;
        }
        this.getList().finally(()=>{
          this.loading = false;
        });
        this.offset += this.limit;
      }, 1000);
    },
    async getList() {
      try {
        const res = await this.$v_http.get(`/getRecommendList?vid=${this.vid}&limit=${this.limit}&offset=${this.offset}`);
        if (res.data?.code==-500) {
          console.error("获取视频列表失败：");
          this.finishedText ="服务器错误！联系管理员"
          this.finished = true;
          return
        }
        if (res.data?.code==-404) {
          console.error("获取视频列表失败：");
          this.finished = true;
          return
        }
        if (res.data?.data?.Videos) {
          const videos = res.data.data.Videos;
          this.videoList = this.offset === 0 ? videos : [...this.videoList, ...videos];
          if (videos.length < 10) this.finished = true;
        }
      } catch (error) {
        console.error("获取视频列表失败：", error);
        this.finished = true;
      }
    },
    handleImageError(event) {
      const img = event.target;
      const randomInteger = Math.floor(Math.random() * 401) + 1;
      if (this.slug=="madou") {
        img.src = require("@/assets" + this.imgErrPath + randomInteger + '.jpg'); // 使用正确的图片路径
      }else {
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }
    },
  },
  created() {
    this.imgErrPath = "/"+this.slug+"/"
  }
}
</script>

<style scoped lang="scss">
.relateVideo{
  position: relative;
  margin-top: 5vw;
  &::before {
    content: "";
    position: absolute;
    z-index: 5;
    left: 0;
    top: 0;
    width: 100%;
    height: 1px;
    background-color: #e7e7e7;
    transform: scaleY(0.5);
  }
  .card_box{
    display: flex;
    flex-wrap: wrap;
    padding: 0 1.33333vmin;
    .v_card {
      width: 50%;
      padding: 2.13333vmin 1.33333vmin;
      display: inline-block;
      box-sizing: border-box;

      .card {
        position: relative;
        background-color: #f3f3f3;
        border-radius: 1.23333vmin;
        overflow: hidden;
        .count{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          font-size: 3.0vmin;
          padding: 1.33333vmin 1.6vmin;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #fff;
          background: linear-gradient(0deg, rgba(0, 0, 0, .85), transparent);
          box-sizing: border-box;
          :nth-child(1){
            display: flex;
            align-items: center;
            gap:2vw;
            span{
              display: flex;
              gap:1vw;
              align-items: center;
              justify-content: center;
            }
          }
          .icon{
            height: 3.5vmin;
          }
        }
      }

      .title {
        font-size: 3.2vmin;
        color: #212121;
        margin-top: 1.6vmin;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .img_wrap {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%; /* 16:9 aspect ratio */
      }

      .bfs_img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: transparent;

        .img_inner {
          display: block;
          width: 100%;
          height: 100%;

          .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
}
.iconfont{
  font-size: 3.3vmin !important;
}
</style>
